import { createContext } from "react";
export const StorybookContext = createContext<boolean | undefined>(undefined);
